import React from 'react';
import cx from 'classnames';

import { InputTitle } from '../../../components/Input';

/**
 * Shared input list container. Currently used for checkboxes and toggles
 */
interface IInputContainer {
  /** Passed down classname. */
  className?: string;
  /** If background has a solid color */
  isReverse?: boolean;
  /** Will provide a border to container */
  includeBorder?: boolean;
  /** Optional title */
  title?: string;
}

export const InputListContainer: React.FC<IInputContainer> = ({
  className,
  children,
  isReverse,
  title,
}) => {
  const combinedToggleContainerClass = cx({
    'panda-input-container': true,
    [className || '']: !!className,
  });

  return (
    <div className={combinedToggleContainerClass}>
      {!!title && <InputTitle isReverse={isReverse} isSmall title={title} />}
      <div className="panda-input-list-container">{children}</div>
    </div>
  );
};
